import { render } from "./TitleView.vue?vue&type=template&id=047344f6&scoped=true"
import script from "./TitleView.vue?vue&type=script&lang=js"
export * from "./TitleView.vue?vue&type=script&lang=js"

import "./TitleView.vue?vue&type=style&index=0&id=047344f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047344f6"]])

export default __exports__